import type * as api from '@gitbook/api-client';
import { Block } from '@gitbook/slate';

import { BLOCK_INTEGRATION, type BlockIntegrationData } from '../types';

export * from './schema';

/**
 * Utility to create a custom block.
 */
export function createIntegrationBlock(
    integration: string,
    block: string,
    props: object = {},
    action: api.ContentKitAction | undefined = undefined,
    fullWidth?: boolean
): Block {
    const data: BlockIntegrationData = {
        integration,
        block,
        props,
        ...(action ? { action } : {}),
        ...(typeof fullWidth !== 'undefined' ? { fullWidth } : {}),
    };

    return Block.createVoid({
        type: BLOCK_INTEGRATION,
        data,
    });
}

/**
 * Utility to create an integration block when unfurling an url
 */
export function createIntegrationBlockForLinkUnfurl(
    integration: string,
    block: string,
    url: string
): Block {
    return Block.createVoid({
        type: BLOCK_INTEGRATION,
        data: createIntegrationBlockDataForLinkUnfurl(integration, block, url),
    });
}

/**
 * Utility to create a the data for an integration block when unfurling an url
 */
export function createIntegrationBlockDataForLinkUnfurl(
    integration: string,
    block: string,
    url: string
): BlockIntegrationData {
    const data: BlockIntegrationData = {
        integration,
        block,
        props: {},
        action: {
            action: '@link.unfurl',
            url,
        },
        url,
    };

    return data;
}
